<mat-form-field
    subscriptSizing="dynamic"
    class="st-date-picker-date"
    [matTooltip]="label()">
    <mat-label
        *ngIf="label"
        class="st-date-picker-label">
        {{ label() }}
    </mat-label>
    <input
        matInput
        [mtxDatetimepicker]="datePicker"
        [required]="required()"
        [readonly]="disabled()"
        [placeholder]="placeholder()"
        [min]="minDate()"
        [formControl]="internalFormControl"
        (dateChange)="dateChange($event.value)" />
    <mtx-datetimepicker
        #datePicker
        [type]="type"
        [mode]="mode"
        [panelClass]="'st-date-picker-calendar'"
        [touchUi]="touchUi">
        <mtx-datetimepicker-actions>
            <button
                mat-button
                mtxDatetimepickerClear>
                {{ clearLabel() }}
            </button>
            <button
                mat-button
                mtxDatetimepickerCancel>
                {{ cancelLabel() }}
            </button>
            <button
                mat-raised-button
                mtxDatetimepickerApply>
                {{ applyLabel() }}
            </button>
        </mtx-datetimepicker-actions>
    </mtx-datetimepicker>
    <mtx-datetimepicker-toggle
        matSuffix
        [for]="datePicker"
        [disabled]="disabled()" />
    <ng-container
        *ngIf="hasSuffix()"
        matSuffix>
        <ng-content select="[suffix]" />
    </ng-container>
    <ng-container
        *ngIf="hasPrefix()"
        matPrefix>
        <ng-content select="[prefix]" />
    </ng-container>
    <ng-container
        *ngIf="hasError()"
        matError>
        <ng-content select="[error]" />
    </ng-container>
</mat-form-field>
